import * as api from '../api/api';

export const sortIDs = ['device', 'import', 'export'] as const;

type SortID = typeof sortIDs[number];

export const typeSortMap: Record<SortID, number> = {
  device: 0,
  import: 1,
  export: 2,
} as const;

export interface DffState {
  mount: api.Mount;
  user: api.User;
  baseUrl: string;
}
